import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import BootstrapVueNext from "bootstrap-vue-next";
import VueApexCharts from "vue3-apexcharts";
import { QuillEditor } from '@vueup/vue-quill'
import Vue3Prism from 'vue3-prism/lib/Vue3Prism.common.js'
import "../node_modules/dropzone/dist/dropzone.css"
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "swiper/css";
import "swiper/css/bundle";
import 'flatpickr/dist/flatpickr.css';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@vueup/vue-quill/dist/vue-quill.bubble.css';
import "vue3-prism/lib/Vue3Prism.css"
import "@vueform/multiselect/themes/default.css";
import "./assets/custom.scss";
import ApiService from "./services/ApiService";
import { createPinia } from "pinia";
import { initVeeValidate } from "./utils/vee-validate";
import 'bootstrap-icons/font/bootstrap-icons.css';

const app = createApp(App)
app.use(router);
app.use(createPinia());
app.use(VueApexCharts);
app.use(BootstrapVueNext);
app.component('QuillEditor', QuillEditor)
.use(Vue3Prism)
initVeeValidate();
ApiService.init(app);

app.mount("#app");
